import React from 'react';

// Code for Header section
const Header = () => {
    return (
        <div className="container mb-4 py-4 ">
            <h1 className="text-success">Arrange A Motivational Seminar For The Youth</h1>
            <h3>Let's make people highly motivated to their goals and help them to become successful </h3>
            <h1 className="text-success">Total budget: 5 Million</h1>
        </div>
    );
};

export default Header;